import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      name: "Admin",
      hostname: window.location.hostname, // Track the current domain
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }));
  }

  componentDidMount() {
    const userData = this.getUserName();
    if (userData) {
      this.setState({ name: userData.username, user: userData.user });
    }

    this.applyThemeBasedOnDomain(); // Apply the theme based on the domain
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if the domain has changed
    if (window.location.hostname !== prevState.hostname) {
      this.applyThemeBasedOnDomain();
    }
  }

  applyThemeBasedOnDomain = () => {
    // Remove any existing theme class from the body
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");

    // Check for selected theme in localStorage
    const selectedTheme = localStorage.getItem("selectedTheme");

    // Determine domain and apply the corresponding default theme if no selected theme
    const domain = window.location.hostname;
    let newTheme = selectedTheme || "theme1"; // Default to theme1 if no theme is selected

    if (!selectedTheme) {
      if (domain.includes("neuronimbus")) {
        newTheme = "theme1"; // youngunns theme
      } else if (
        domain.includes("dev") ||
        domain.includes("youngunns") ||
        domain.includes("demo")
      ) {
        newTheme = "theme2"; // pizza theme
      } else if (domain.includes("green")) {
        newTheme = "theme3"; // green theme
      } else if (domain.includes("yellow")) {
        newTheme = "theme4"; // yellow theme
      }
    }

    // Apply the theme
    document.body.classList.add(newTheme);

    // Store the current domain in the state to detect future changes
    this.setState({ hostname: window.location.hostname });
  };

  componentWillUnmount() {
    // Cleanup: Remove theme classes when the component unmounts
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");
  }

  getUserName() {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      return obj;
    }
    return null;
  }



  handleThemeChange = themeKey => {
    // Remove the previous theme class from the body
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");

    // Add the new theme class
    document.body.classList.add(themeKey);

    // Store the selected theme in localStorage
    localStorage.setItem("selectedTheme", themeKey);

    // Reload the page to apply the new theme
    // window.location.reload();
  };

  render() {
    const profile_pic =
      JSON.parse(localStorage.getItem("roleWiseAccess"))?.profile_pic || "";

    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item"
            id="page-header-user-dropdown"
            tag="button"
          >
            <div className="profile-icon">
              <h5>{"A"}</h5>
            </div>
            <span className="d-none d-xl-inline-block ms-1">
              {this.state.name}
            </span>
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            {/* <DropdownItem tag="a" href="#">
              <div className="theme-buttons">
                <button
                  className="btn btn-sm blueTheme"
                  onClick={() => this.handleThemeChange("theme1")}
                ></button>
                <button
                  className="btn btn-sm redTheme"
                  onClick={() => this.handleThemeChange("theme2")}
                ></button>
                <button
                  className="btn btn-sm greenTheme"
                  onClick={() => this.handleThemeChange("theme3")}
                ></button>
                <button
                  className="btn btn-sm yellowTheme"
                  onClick={() => this.handleThemeChange("theme4")}
                ></button>
              </div>
            </DropdownItem> */}
            <Link
              to={`/edit-user/${this.state.user?.id}`}
              className="dropdown-item"
            >
              <i className="bx bx-user font-size-16 align-middle ms-1" />
              <span>Profile</span>
            </Link>
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span>Logout</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.string,
};

const mapStateToProps = state => {
  const { success } = state.Profile;
  return { success };
};

export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu))
);
